import { Visibility } from "@mui/icons-material";
import { Box, IconButton, Tooltip } from "@mui/material";
import { convertDateWithValidation, dateFormatterWithTime } from "../helper/losDataHelper";

    export const initialAppInfoValues = 
    {
        internalapplicationid: "",
        leadid: "",
        branchcode: "",
        applicationnumber: "",
        applicationgenerateddate: "",
        loantype: "",
        institutionname: "",
        loanamount: "",
        purposeofloan: "",
        roi: "",
        tenure: "",
        emiamount: "",
        loanusagedesc: "",
        internalcustomerid: "",
        customerid: "",
        capacitycode: "",
        relationshipid: "",
        dedupecheckid: "",
        isconsentgiven: "",
        consentgivendate: "",
        consentdocumentnumber: "",
        iskycdone: "",
        isapplicantdroped: "",
        createdUser: ""
    };

    export const ApplicationInfoListColumn = [
      {
        field: "internalapplicationid",
        headerName: "Internal Application ID",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
      },
      {
        field: "internalcustomerid",
        headerName: "Internal Customer ID",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
      },
      {
        field: "leadid",
        headerName: "Lead ID",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
      },
      {
        field: "customerid",
        headerName: "Customer ID",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
      },
      {
        field: "applicationnumber",
        headerName: "Application Number",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
      },
      {
        field: "applicationgenerateddate",
        headerName: "Application Generated Date",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
        valueGetter: (params) => convertDateWithValidation(params.row.applicationgenerateddate)
      },
      {
        field: "createdDate",
        headerName: "Created Date",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
        valueGetter: (params) => dateFormatterWithTime(params.row.createdDate)
      },
      {
        field: "lastModifiedDate",
        headerName: "Last Modified Date",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
        valueGetter: (params) =>  dateFormatterWithTime(params.row.lastModifiedDate)
      },
      {
        field: "icon",
        headerName: "",
        headerAlign: "center",
        align: "center",
        maxWidth: 50,
        type: "string",
        editable: false,
        renderCell: (params) => {
          return (
            <Box
              sx={{
                justifyContent: "center",
                display: "flex",
                width: 25,
                flex: 1,
              }}
            >
              <Tooltip title="View Detail">
                <IconButton
                  onClick={(e) => {
                      viewApplicantDetail(params);
                  }}
                >
                  <Visibility sx={{ color: "black" }} />
                </IconButton>
              </Tooltip>
            </Box>
          );
        },
      }
    ]

    export const CollateralAddressInfoColumns = [
      {
        field: "propertyaddressid",
        headerName: "Property Address ID",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
      },
      {
        field: "internalapplicationid",
        headerName: "Internal Application ID",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
      },
      {
        field: "collateralassessmentid",
        headerName: "Collateral Assessment ID",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
      },
      {
        field: "addresstype",
        headerName: "Address Type",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
      },
      {
        field: "internalcustomerid",
        headerName: "Internal Customer ID",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
      },
      {
        field: "flatdoorbuildingblock",
        headerName: "Flat/Door/Building/Block",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
      },
      {
        field: "roadstreet",
        headerName: "Road/Street",
        headerAlign: "center",
        align: "center",
        flex: 250,
        type: "string",
        editable: false,
      },
      {
        field: "arealocality",
        headerName: "Area/Locality",
        headerAlign: "center",
        align: "center",
        flex: 250,
        type: "string",
        editable: false,
      },
      {
        field: "citytown",
        headerName: "City/Town",
        headerAlign: "center",
        align: "center",
        flex: 250,
        type: "string",
        editable: false,
      },
      {
        field: "state",
        headerName: "State",
        headerAlign: "center",
        align: "center",
        flex: 250,
        type: "string",
        editable: false,
      },
      {
        field: "landmark",
        headerName: "Landmark",
        headerAlign: "center",
        align: "center",
        flex: 250,
        type: "string",
        editable: false,
      },
      {
        field: "pinCode",
        headerName: "PinCode",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
      },
      {
        field: "isresidentialsameaspermanent",
        headerName: "Is Residential Same As Permanent",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
      }
    ]

    const viewApplicantDetail = (param) => {
      window.open(`/stlap/home/losData/applicantInfoList/${param.id}`, "_blank");
    }

    export const applicantInfoListData = async(values) => {
      let dataList = [];
      values.forEach(v => {
       dataList.push({
        internalapplicationid: v['internalapplicationid'], internalcustomerid: v['internalcustomerid'], 
        leadid: v['leadid'], customerid: v['customerid'], applicationnumber: v['applicationnumber'], 
        applicationgenerateddate: v['applicationgenerateddate'],
        createdDate: v['createdDate'],
        lastModifiedDate:  v['lastModifiedDate']
       });
      });
      return dataList;    
     }